module.exports = __webpack_public_path__ + "static/img/new9-Mw8cRk5P.138dc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new9-Mw8cRk5P.png
// module id = 9ZGq
// module chunks = 16